import { render, staticRenderFns } from "./field.vue?vue&type=template&id=2738cbfb"
import script from "./field.vue?vue&type=script&lang=ts"
export * from "./field.vue?vue&type=script&lang=ts"
import style0 from "./field.vue?vue&type=style&index=0&id=2738cbfb&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports